<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    id="geofences-list-and-map"
    class="flex-full"
    :class="{ 'has-modal-in-modal': inModal }">
    <div class="pane-and-map">
      <div class="map-panes">
        <div
          class="map-panes-left"
          :style="`max-height: ${maxHeight}rem`">
          <div
            v-if="isEditable"
            class="map-pane map-pane-search">
            <div class="map-pane-content pad">
              <div class="search-input-pane">
                <input
                  id="map_search_text"
                  ref="placeSearchTextInput"
                  v-model="placeSearchText"
                  name="name"
                  type="text"
                  :placeholder="
                    isNotChina
                      ? $t('messages.searchPlacesExample', appropriateSearchPlaceholder(organization.currency))
                      : $t('messages.searchPlacesExampleBaidu')
                  "
                  :class="{ 'form-control': true, input: true }"
                  @keyup.enter="isNotChina ? queryGeofences2() : queryGeofencesBaidu()"
                  @focus="isSearchTooltipVisible = true"
                  @blur="isSearchTooltipVisible = false" />
                <button
                  class="btn btn-primary btn-sm btn-no-text"
                  @click="isNotChina ? queryGeofences2() : queryGeofencesBaidu()">
                  <icon-search />
                </button>
                <div
                  v-if="isSearchTooltipVisible"
                  class="map-search-tooltip scale-vertical">
                  <div class="callout">
                    <icon-play2 />
                  </div>
                  <div
                    v-sanitize-html="
                      isNotChina
                        ? i18n.global.t(
                            'messages.geofenceGroupMapSearchTooltip',
                            appropriateToolTip(organization.currency),
                          )
                        : i18n.global.t('messages.geofenceGroupBaiduMapSearchTooltip')
                    " />
                </div>
              </div>
              <div
                v-if="genericGeofencesAvailable && isNotChina"
                class="import-postal-codes">
                <a
                  class="flex-h"
                  @click="isGenericGeofenceSearchModalVisible = true">
                  <icon-search class="mr-2" />
                  <small>{{ $t('actions.searchForPostalCodesEtc') }}</small>
                </a>
              </div>
            </div>
          </div>
          <div
            id="geofence_listmapInternal_pane"
            class="map-pane fill">
            <div class="map-pane-header">
              <div style="width: 100%">
                <span>
                  {{ capitalize($t('names.geofence', { n: 2 })) }}
                  <span v-if="geofenceGroup.geofences.length > 0"> ({{ geofenceGroup.geofences.length }}) </span>
                </span>
                <div class="actions">
                  <button
                    v-show="!isSlideShowRunning"
                    v-tooltip.top="capitalize($t('actions.fitAllGeofencesIntoView'))"
                    class="btn btn-default btn-xs btn-no-text"
                    :disabled="!geofenceGroup.geofences?.length"
                    @click="fitAllGeofencesIntoView()">
                    <icon-fit-into-view />
                  </button>
                  <button
                    v-show="!isSlideShowRunning && isNotChina"
                    v-tooltip.top="capitalize($t('actions.startSlideshow'))"
                    class="btn btn-default btn-xs btn-no-text"
                    :disabled="!geofenceGroup.geofences?.length"
                    @click="startSlideShow">
                    <icon-play />
                  </button>
                  <button
                    v-show="isSlideShowRunning && isNotChina"
                    v-tooltip.top="capitalize($t('actions.stopSlideshow'))"
                    class="btn btn-default btn-xs btn-no-text"
                    :disabled="!geofenceGroup.geofences?.length"
                    @click="stopSlideShow">
                    <icon-stop />
                  </button>
                  <button
                    v-if="isEditable && geofenceGroup.geofences?.length > 0"
                    v-tooltip.top="capitalize($t('actions.deleteAll'))"
                    class="btn btn-default btn-xs btn-no-text"
                    :disabled="!geofenceGroup.geofences?.length"
                    @click="deleteAllGeofences">
                    <icon-delete />
                  </button>
                  <button
                    v-if="isEditable && !geofenceGroup.geofences?.length && disabledGeofences?.length > 0"
                    v-tooltip.top="capitalize($t('actions.restoreAll'))"
                    class="btn btn-default btn-xs btn-no-text"
                    @click="restoreAllGeofences">
                    <icon-restore />
                  </button>
                  <button
                    v-tooltip.top="capitalize($t('actions.downloadGeofences'))"
                    class="btn btn-default btn-xs btn-no-text"
                    :disabled="!geofenceGroup.geofences?.length"
                    @click="exportGeofenceGroup">
                    <icon-download />
                  </button>
                  <button
                    v-if="isEditable"
                    v-tooltip.top="capitalize($t('actions.uploadFile'))"
                    name="uploadPlaces"
                    class="btn btn-default btn-xs btn-no-text"
                    @click="showCSVUploadModal">
                    <icon-upload />
                  </button>
                  <button
                    v-if="isNotChina"
                    v-tooltip.top="capitalize($t('actions.previewScreens'))"
                    name="previewInventory"
                    class="btn btn-default btn-xs btn-no-text"
                    :disabled="!geofenceGroup.geofences?.length"
                    @click="previewGeofenceGroupSites">
                    <icon-screen />
                  </button>
                </div>
              </div>
              <div
                v-if="isEditable && false"
                class="default-circle-radius">
                <div class="title">{{ $t('messages.defaultRadius') }}</div>
                <input
                  v-model="circleRadiusDistance"
                  type="number"
                  min="1"
                  max="5000" />
                <select v-model="circleRadiusDistanceUnit">
                  <option value="mi">mi</option>
                  <option value="ft">ft</option>
                  <option value="km">km</option>
                  <option
                    selected="selected"
                    value="m">
                    m
                  </option>
                </select>
              </div>
            </div>
            <div
              id="geofence_list_container"
              class="map-pane-content">
              <geofence-list
                ref="geofenceList"
                :active-geofences="geofenceGroup.geofences"
                :disabled-geofences="disabledGeofences"
                :active-geofence="activeGeofence"
                :is-editable="isEditable"
                :show-exclude-checkbox="true"
                @select-geofence="selectGeofence"
                @unselect-geofence="unselectGeofence"
                @geofence-clicked="(geofence) => zoomToGeofence(geofence, true)" />
            </div>
          </div>
        </div>
      </div>

      <!-- MAP -->
      <div
        class="map-container"
        :class="isSlideShowRunning ? 'slideshow-running' : ''">
        <div
          class="download-screens-pane"
          :class="
            isSlideShowRunning || unitsInGeofenceGroup == null || unitsInGeofenceGroup.length === 0 ? 'hidden' : ''
          ">
          <button
            v-if="isSupplyOrganization || organizationSettings.uiEnableLineItemSiteTargeting"
            class="btn btn-primary btn-sm ml-3 mb-2"
            @click="exportSites">
            <icon-download />
            {{ capitalize($t('actions.downloadSites')) }}
          </button>
          <button
            v-if="isSupplyOrganization || organizationSettings.uiEnableLineItemUnitTargeting"
            class="btn btn-primary btn-sm ml-3 mb-2"
            @click="exportUnits">
            <icon-download />
            {{ capitalize($t('actions.downloadScreens')) }}
          </button>
          <div class="filler" />
          <button
            class="btn btn-sm btn-default mb-2"
            @click="closeSlideShow">
            &times;
          </button>
        </div>

        <div
          class="slideshow-active-geofence-pane"
          :class="activeSlideShowGeofence === null ? 'hidden' : ''">
          <icon-colored-info />
          <div
            v-if="activeSlideShowGeofence !== null"
            class="name-and-description">
            <strong>{{ activeSlideShowGeofence.name }}</strong>
            <span>{{ activeSlideShowGeofence.description }}</span>
          </div>
        </div>
        <geofences-list-and-map-mapbox
          v-if="isNotChina"
          ref="mapboxMap"
          class="map"
          :is-editable="isEditable"
          :active-geofence="activeGeofence"
          :geofence-group="geofenceGroup"
          :units-in-geofence-group="unitsInGeofenceGroup"
          @point-clicked="(id, showPopup, zoomToGeofence) => activateGeofence(id, showPopup, zoomToGeofence)"
          @highlight-geofence="highlightGeofence"
          @delete-geofence="unselectGeofence"
          @point-created="
            (point) => {
              isGeofenceFromCoordinateCreationModalVisible = true;
              lastPointCoordinate = point;
            }
          "
          @polygon-drawn="
            (polygon, isPolygonFrom3dBuilding) => handleNewPolygonCreationMapbox(polygon, isPolygonFrom3dBuilding)
          "
          @add-geofences="(geofences) => addGeofencesToMap(geofences)"
          @clear-active-geofence="activeGeofence = null" />
        <geofences-list-and-map-baidu
          v-else
          id="geofence_group_map_internal"
          ref="baiduMap"
          class="map"
          :geofences="geofenceGroup.geofences"
          :active-geofence="activeGeofence"
          :enable-map-point-control="isEditable"
          :enable-map-polygon-control="isEditable"
          :enable-map-style-control="true"
          :allow-clear-geofence="isEditable"
          :clear-new-polygon="clearNewPolygon"
          @point-clicked="
            (geofence) => {
              activateGeofence(geofence.id);
            }
          "
          @polygon-created="(polygon, results) => handleNewPolygonCreationBaidu(polygon, results)"
          @polygon-cleared="clearNewPolygon = false"
          @point-added="(point, results) => handleNewPointCreation(point, results)" />

        <div
          v-if="activeGeofence != null && isActiveGeofenceCircleRadiusPaneVisible"
          class="radius-map-pane visible">
          <h3>
            {{ activeGeofence.name }}
            <span v-if="isPolygonLoading">
              <LoaderSmall />
            </span>
          </h3>

          <DynamicGeofences
            v-if="showDynamicGeofence"
            ref="dynamicGeofences"
            :geofences="[activeGeofence]"
            :map-instance="map.map"
            :horizontal="false"
            :is-handling-drawing="false"
            @on-dynamic-geofence-updated="onDynamicGeofenceUpdated"
            @on-polygons-loading="(val) => (isPolygonLoading = val)"
            @on-polygon-clicked="(id, showPopup, zoomToGeofence) => activateGeofence(id, showPopup, zoomToGeofence)" />

          <radius-distance
            v-else
            :radius-distance-in-meters="activeGeofence.radius * 1000"
            :radius-unit="activeGeofence.radiusUnit || null"
            :radius-in-unit="activeGeofence.radiusInUnit || null"
            @radius-changed="handleActiveGeofenceCircleRadiusDistanceChange" />

          <a @click="applyActiveGeofenceRadiusToAllGeofences">
            <icon-reset />
            <small>{{ capitalize($t('messages.applyRadiusToAllGeofences')) }}</small>
          </a>
          <a
            v-if="isNotChina"
            @click="convertPointGeofenceToPolygonGeofence">
            <icon-polygon />
            <small>{{ capitalize($t('actions.changeToPolygon')) }}</small>
          </a>
          <a
            v-if="!showRadius"
            @click="convertToRadius">
            <icon-radius />
            <small>{{ $t('messages.changeToRadiusGeofences') }}</small>
          </a>
          <a
            v-show="canUseDynamicGeofences && !showDynamicGeofence"
            @click="convertToDynamicGeofence">
            <span v-tooltip.right="$t('messages.betaFeature', [capitalize($t('messages.dynamicGeofences'))])">
              <SimpleDynamicGeofence />
              <small
                >{{ $t('messages.changeToDynamicGeofence') }} <span class="badge badge-info ml-3">beta</span></small
              >
            </span>
          </a>
        </div>
      </div>
    </div>

    <geofence-file-upload
      ref="geofenceFileUpload"
      :geofence-group="geofenceGroup"
      :is-editable="isEditable"
      :last-geofences-imported="lastGeofencesImported"
      @add-geofences="
        (geofences) => {
          addGeofencesToMap(geofences);
        }
      " />

    <sites-file-download
      ref="sitesFileDownload"
      :name="geofenceGroup.name"
      :units="unitsInGeofenceGroup" />

    <geofence-sites-file-download
      ref="geofenceSitesFileDownload"
      :name="geofenceGroup.name"
      :sites="siteGeofencesToExport" />

    <geofence-units-file-download
      ref="geofenceUnitsFileDownload"
      :name="geofenceGroup.name"
      :units="unitGeofencesToExport" />

    <geofence-file-download
      ref="geofenceFileDownload"
      :geofence-group="geofenceGroup" />

    <geofence-list-selection-modal
      v-if="isGeofenceListSelectionModalVisible && isEditable"
      ref="geofenceSearchResultModal"
      :place-geofences="geofenceQueryResult"
      :is-visible="isGeofenceListSelectionModalVisible"
      @hide-loader="
        () => {
          showLocalLoader = false;
        }
      "
      :requested-for-utc="requestedForUtc"
      @confirmed="selectGeofencesSearchResultModalConfirmed"
      @cancelled="selectGeofencesSearchResultModalCancelled" />

    <create-geofence-from-polygon-modal
      v-if="isEditable"
      :is-visible="isGeofenceFromPolygonCreationModalVisible"
      :point-geofences="pointGeofences"
      :in-polygon-geofences="pointGeofencesInNewlyDrawnPolygon"
      :near-polygon-geofences="pointGeofencesNearNewlyDrawnPolygon"
      :polygon="isNotChina ? newlyDrawnPolygon : newlyDrawnPolygonBaidu"
      :places-near-by-new-polygon="placesNearByNewPolygon"
      :is-from3d-building="isNewlyDrawnPolygonFrom3dBuilding"
      :is-not-china="isNotChina"
      @confirmed="confirmGeofenceCreationFromPolygon"
      @cancelled="cancelGeofenceCreationFromPolygon" />

    <create-geofence-from-coordinate-modal
      v-if="isEditable"
      :is-visible="isGeofenceFromCoordinateCreationModalVisible"
      :coordinate="lastPointCoordinate"
      :is-not-china="isNotChina"
      :places-near-by-new-point="placesNearByNewPoint"
      @confirmed="confirmGeofenceCreationFromCoordinate"
      @cancelled="cancelGeofenceCreationFromCoordinate" />

    <generic-geofence-search-modal
      v-if="isGenericGeofenceSearchModalVisible && isEditable"
      :is-visible="isGenericGeofenceSearchModalVisible"
      :is-fullscreen="!inModal"
      :requested-for-utc="requestedForUtc"
      @confirmed="confirmGeofenceCreationFromGeneric"
      @cancelled="cancelGeofenceCreationFromGeneric" />

    <div
      id="place_popup_content"
      style="display: none">
      <div class="place-popup-content">
        <icon-colored-info />
        <div
          v-if="activeGeofence != null"
          class="name-and-description">
          <strong>{{ activeGeofence.name }}</strong>
          <span>{{ activeGeofence.description }}</span>
        </div>
      </div>
    </div>

    <modal
      :visible="isNoSearchResultsModalVisible"
      :title="capitalize($t('messages.noPlacesFound'))"
      :body="capitalize($t('messages.noPlacesWereFoundTrySpecifyingAnMoreAccurateAddress'))"
      :button1-caption="capitalize($t('actions.ok'))"
      :button2-visible="false"
      @confirmed="isNoSearchResultsModalVisible = false"
      @cancelled="isNoSearchResultsModalVisible = false" />

    <unbranded-loader
      v-if="isFetchingPlaces"
      :message="findingLocationsMessage" />

    <unbranded-loader
      v-else-if="showLocalLoader"
      :message="loadingGeofencesWarningMessage" />
  </div>
</template>

<script lang="ts">
  import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

  import turfCentroid from '@turf/centroid';
  import * as turf from '@turf/helpers';
  import GeoPoint from 'geopoint';
  import { DateTime } from 'luxon';
  import { capitalize } from 'vue';
  import { mapActions, mapGetters, mapState } from 'vuex';

  import OpenStreetMapApi from '@/common/apis/openStreetMapsApi';
  import DynamicGeofences from '@/common/components/controls/dynamic-geofences/DynamicGeofences.vue';
  import SimpleDynamicGeofence from '@/common/components/controls/dynamic-geofences/icons/SimpleDynamicGeofence.vue';
  import GeofenceList from '@/common/components/controls/GeofenceList.vue';
  import LoaderSmall from '@/common/components/controls/LoaderSmall.vue';
  import UnbrandedLoader from '@/common/components/UnbrandedLoader.vue';
  import DistanceUnit from '@/common/enums/DistanceUnit.enum';
  import { IconColoredInfo } from '@/common/icons/colored';
  import {
    IconDelete,
    IconDownload,
    IconFitIntoView,
    IconPlay,
    IconPlay2,
    IconPolygon,
    IconRadius,
    IconReset,
    IconRestore,
    IconScreen,
    IconSearch,
    IconStop,
    IconUpload,
  } from '@/common/icons/monochrome';
  import { GeofenceGroup } from '@/common/models';
  import Geofence from '@/common/models/geo/Geofence';
  import GeofenceGroupType from '@/common/models/geofenceGroups/GeofenceGroupType.enum';
  import Filter from '@/common/models/query-params/Filter';
  import FilterCollection from '@/common/models/query-params/FilterCollection';
  import * as ComparisonOperator from '@/common/models/query-params/FilterComparisonOperator';
  import QueryParams from '@/common/models/query-params/QueryParams';
  import GlobalEventBus from '@/GlobalEventBus';
  import GlobalEvents from '@/GlobalEvents';
  import {
    getContainerHeight,
    getContainerWidth,
    getDistanceFromLatLonInKm,
    isPointInsidePolygon,
    loadGooglePlacesApi,
    region,
    Regions,
  } from '@/globals';
  import GeofencesUtils from '@/org-app/components/geofenceGroups/Geofences.utils';
  import Centroid from '@/utils/Centroid';
  import UnitConverter from '@/utils/UnitConverter';
  import UserNotifications from '@/utils/UserNotifications';
  import i18n from '@/vueI18n';

  import CreateGeofenceFromCoordinateModal from './CreateGeofenceFromCoordinateModal.vue';
  import CreateGeofenceFromPolygonModal from './CreateGeofenceFromPolygonModal.vue';
  import GenericGeofenceSearchModal from './GenericGeofenceSearchModal.vue';
  import GeofenceFileDownload from './GeofenceFileDownload.vue';
  import GeofenceFileUpload from './GeofenceFileUpload.vue';
  import GeofenceListSelectionModal from './GeofenceListSelectionModal.vue';
  import GeofenceSiteModel from './GeofenceSiteModel';
  import GeofenceSitesFileDownload from './GeofenceSitesFileDownload.vue';
  import GeofencesListAndMapBaidu from './GeofencesListAndMapBaidu.vue';
  import GeofencesListAndMapMapbox from './GeofencesListAndMapMapbox.vue';
  import GeofenceUnitModel from './GeofenceUnitModel';
  import GeofenceUnitsFileDownload from './GeofenceUnitsFileDownload.vue';
  import PlaceSearchEngine from './PlaceSearchEngine';
  import PlaceSearchEngineBaidu from './PlaceSearchEngineBaidu';
  import RadiusDistance from './RadiusDistance.vue';
  import SitesFileDownload from './UnitsFileDownload.vue';

  export default {
    components: {
      IconRadius,
      SimpleDynamicGeofence,
      LoaderSmall,
      DynamicGeofences,
      GenericGeofenceSearchModal,
      CreateGeofenceFromCoordinateModal,
      CreateGeofenceFromPolygonModal,
      GeofenceFileDownload,
      SitesFileDownload,
      GeofenceFileUpload,
      GeofenceSitesFileDownload,
      GeofencesListAndMapBaidu,
      GeofencesListAndMapMapbox,
      GeofenceUnitsFileDownload,
      GeofenceListSelectionModal,
      IconColoredInfo,
      IconDownload,
      IconDelete,
      IconFitIntoView,
      IconPlay,
      IconPlay2,
      IconPolygon,
      IconReset,
      IconRestore,
      IconSearch,
      IconStop,
      IconUpload,
      IconScreen,
      UnbrandedLoader,
      RadiusDistance,
      GeofenceList,
    },
    props: {
      isEditable: {
        type: Boolean,
        default: false,
      },
      geofenceGroup: {
        type: GeofenceGroup,
      },
      inModal: {
        type: Boolean,
        default: false,
      },
      maxHeight: {
        type: Number,
      },
    },
    data() {
      return {
        activeGeofence: null,
        activeSlideShowGeofence: null,
        areGeofenceBoundingBoxesVisible: false, // For debugging bounding boxes.
        circleRadiusDistance: 25,
        circleRadiusDistanceUnit: DistanceUnit.METER,
        clusterRadius: 40,
        createMapLayersTimer: null,
        disabledGeofences: [],
        geofenceQueryExecutionId: null,
        google: null,
        googleGeofenceQueryResult: [],
        i18n,
        isActiveGeofenceCircleRadiusPaneVisible: false,
        isConvertingPointGeofenceToPolygonGeofence: false,
        isFetchingPlaces: false,
        isGenericGeofenceSearchModalVisible: false,
        isGeofenceFromCoordinateCreationModalVisible: false,
        isGeofenceFromPolygonCreationModalVisible: false,
        isGeofenceListSelectionModalVisible: false,
        isNewlyDrawnPolygonFrom3dBuilding: false,
        isNoSearchResultsModalVisible: false,
        isPolygonLoading: false,
        isRunningGeofenceQuery: false,
        isSearchTooltipVisible: false,
        isSlideShowRunning: false,
        lastGeofencesImported: null,
        lastPointCoordinate: null,
        newlyDrawnPolygon: null,
        newlyDrawnPolygonBaidu: null,
        newlyDrawnPolygonHeight: null,
        clearNewPolygon: false,
        osmGeofenceQueryResult: [],
        placeSearchText: null,
        pointGeofencesInNewlyDrawnPolygon: [],
        pointGeofencesNearNewlyDrawnPolygon: [],
        searchPlaceResult: [],
        selectedPlaceIdsFromPlaceSearchResult: [],
        showGeofenceWarningMessage: false,
        showLocalLoader: false,
        slideShowRotationTimer: null,
        slideShowGeofenceIndex: 0,
        slideShowFlyBetweenGeofencesTimer: null,
        slideShowRotationDelayTimer: null,
        fullSites: [],
        currentSitePopup: null,
        unitsInGeofenceGroup: null,
        siteGeofencesToExport: null,
        unitGeofencesToExport: null,
        placesNearByNewPoint: [],
        placesNearByNewPolygon: [],
        showDynamicGeofence: false,
        showRadius: true,
        cancelLoadUnitsTokenSource: null,
      };
    },
    computed: {
      ...mapState('orgApp', {
        organizationSettings: (state) => state.organizationSettings,
        organization: (state) => state.organization,
        genericGeofenceGroupTypeCountries: (state) => state.GeofenceGroups.genericGeofenceGroupTypeCountries,
      }),
      ...mapGetters('orgApp', ['isSupplyOrganization', 'isDemandOrganization']),
      geofenceQueryResult() {
        const merged = this.googleGeofenceQueryResult.map((x) => {
          // Find points within 50 meters
          const matches = this.osmGeofenceQueryResult.filter(
            (y) => getDistanceFromLatLonInKm(x.lat, x.lng, y.lat, y.lng) <= 0.05,
          );
          const withPolygon = matches.filter((y) => !y.isPoint);
          if (withPolygon.length > 0) {
            x.geoJson = withPolygon[0].geoJson;
            x.isPoint = false;
          }
          return x;
        });
        return merged.sort((a, b) => a.description.toLowerCase().localeCompare(b.description.toLowerCase()));
      },
      pointGeofences() {
        return this.geofenceGroup.geofences.filter((x) => x.isPoint);
      },
      circleRadiusInKilometers() {
        return UnitConverter.convertDistance(
          this.circleRadiusDistance,
          this.circleRadiusDistanceUnit,
          DistanceUnit.KILOMETER,
        );
      },
      activeGeofenceRadius: {
        get() {
          return this.activeGeofence !== null ? this.activeGeofence.radius : 0.05;
        },
        set(radius) {
          if (this.activeGeofence !== null) {
            this.updateGeofenceRadius({ geofence: this.activeGeofence, value: radius });
          }
        },
      },
      genericGeofencesAvailable() {
        return this.genericGeofenceGroupTypeCountries.length > 0;
      },
      map() {
        return this.isNotChina ? this.$refs.mapboxMap : this.$refs.baiduMap;
      },
      isNotChina() {
        return region !== Regions.China;
      },
      loadingGeofencesWarningMessage() {
        return this.showGeofenceWarningMessage
          ? i18n.global.t('messages.loadingGeofences')
          : this.capitalize(i18n.global.t('states.loading'));
      },
      findingLocationsMessage() {
        return i18n.global.t('messages.findingLocations');
      },
      canUseDynamicGeofences() {
        return this.organizationSettings.uiEnableDynamicGeofences;
      },
      requestedForUtc() {
        return this.geofenceGroup?.createdOnUtc ?? DateTime.utc();
      },
    },
    methods: {
      ...mapActions([
        'updateGeofenceIsPoint',
        'updateGeofenceExtrusion',
        'updateGeofenceRadius',
        'updateGeofenceRadiusUnit',
        'updateGeofenceRadiusInUnit',
        'updateGeofenceMapboxDrawID',
        'updateGeofenceLat',
        'updateGeofenceLng',
        'updateGeofenceGeoJson',
        'updateGeofenceGeofenceGroupID',
        'updateGeofenceGroupGeofences',
      ]),
      ...mapActions('orgApp', [
        'previewGeofenceGroup',
        'getUnits',
        'getGeofenceUnitMappingForUnits',
        'getGeofenceSiteMappingForSites',
        'getGenericGeofenceGroupTypeCountries',
        'getOrganizationSettings',
        'getUnitsBriefUsingPost',
        'getSitesBriefUsingPost',
      ]),
      async previewGeofenceGroupSites() {
        try {
          this.unitsInGeofenceGroup = await this.previewGeofenceGroup({
            geofenceGroup: this.geofenceGroup,
            useSaved: !this.isEditable,
            buyFromDealsEnabled: this.isDemandOrganization,
          });
          if (this.unitsInGeofenceGroup.length === 0) {
            UserNotifications.info({
              title: i18n.global.t('messages.noSitesUnitsInGeofenceGroupTitle'),
              message: i18n.global.t('messages.noSitesUnitsInGeofenceGroupMessage'),
            });
          }
        } catch (err) {
          UserNotifications.somethingWentWrong(err);
          throw err;
        }
      },
      async exportUnits() {
        GlobalEventBus.$emit(GlobalEvents.loading);
        this.unitGeofencesToExport = await this.getGeofenceUnitExportEntries(this.geofenceGroup.id);
        GlobalEventBus.$emit(GlobalEvents.loaded);
        this.$refs.geofenceUnitsFileDownload.show();
      },
      async exportSites() {
        GlobalEventBus.$emit(GlobalEvents.loading);
        this.siteGeofencesToExport = await this.getGeofenceSiteExportEntries(this.geofenceGroup.id);
        GlobalEventBus.$emit(GlobalEvents.loaded);
        this.$refs.geofenceSitesFileDownload.show();
      },
      // GEOFENCE UNIT - EXPORT ENTRIES
      async getGeofenceUnitExportEntries(geofenceGroupID) {
        if (this.unitsInGeofenceGroup == null) {
          await this.previewGeofenceGroupSites();
        }
        const geofenceUnitIDs = this.unitsInGeofenceGroup.map((x) => x.unitID);
        if (this.isEditable) {
          return this.geofenceUnitExportEntriesForEditView(geofenceUnitIDs);
        }
        return this.geofenceUnitExportEntriesForDetailsView(geofenceUnitIDs, geofenceGroupID);
      },
      async geofenceUnitExportEntriesForEditView(geofenceUnitIDs) {
        const unitExportEntries = [];
        const unitsBrief = await this.getUnitsBriefUsingPost({ unitIDs: geofenceUnitIDs });
        unitsBrief.forEach((unit) => {
          const geofenceUnitModel = this.getUnitModel(unit);
          unitExportEntries.push(geofenceUnitModel);
        });
        return unitExportEntries;
      },
      async geofenceUnitExportEntriesForDetailsView(geofenceUnitIDs, geofenceGroupID) {
        const batchSize = 200;
        const unitIdBatches = geofenceUnitIDs.reduce((mem, x, i) => {
          const batchIndex = Math.floor(i / batchSize);
          if (mem[batchIndex] == null) {
            mem[batchIndex] = [x];
          } else {
            mem[batchIndex].push(x);
          }
          return mem;
        }, []);

        const results = await Promise.all(
          unitIdBatches.map((batch) => this.getGeofenceUnitMappingForUnits({ geofenceGroupID, unitIDs: batch })),
        );
        const uniqueUnitIDs = new Set();
        const geofenceById = new Map();
        const unitBriefById = new Map();

        this.geofenceGroup.geofences.forEach((geofence) => {
          geofenceById.set(geofence.id, geofence);
        });

        results.forEach((geofenceUnitMapping) => {
          Object.values(geofenceUnitMapping).forEach((unitIDs) => {
            unitIDs.forEach((unitID) => {
              uniqueUnitIDs.add(unitID.unit_id);
            });
          });
        });

        const unitsBrief = await this.getUnitsBriefUsingPost({ unitIDs: Array.from(uniqueUnitIDs).flat() });
        unitsBrief.forEach((unitBrief) => {
          unitBriefById.set(unitBrief.unitID, unitBrief);
        });

        const unitExportEntries = [];

        results.forEach((geofenceUnitMapping) => {
          Object.entries(geofenceUnitMapping).forEach((entry) => {
            const [geofenceID, unitIDs] = entry;
            const geofence = geofenceById.get(Number(geofenceID));
            unitIDs.forEach((unitMappingEntry) => {
              const unitID = unitMappingEntry.unit_id;
              const distanceFromCentroid = unitMappingEntry.distance_from_centroid;
              const unitBrief = unitBriefById.get(unitID);
              const geofenceUnitModel = this.getUnitModel(unitBrief, geofence, distanceFromCentroid);
              unitExportEntries.push(geofenceUnitModel);
            });
          });
        });
        return unitExportEntries;
      },
      getUnitModel(unitBrief, geofence, distanceFromCentroid) {
        return new GeofenceUnitModel(
          geofence?.name,
          geofence?.description,
          geofence?.lat,
          geofence?.lng,
          geofence?.tags,
          unitBrief.siteExternalID,
          unitBrief.siteName,
          unitBrief.city,
          unitBrief.region,
          unitBrief.externalID,
          unitBrief.unitID,
          unitBrief.name,
          unitBrief.latitude,
          unitBrief.longitude,
          distanceFromCentroid,
          unitBrief.screenWidth,
          unitBrief.screenHeight,
          unitBrief.networkName,
          unitBrief.mediaOwnerName,
          unitBrief.mediaTypeFullName,
          unitBrief.marketNames,
          unitBrief.unitIABBlock,
          unitBrief.spotLength,
          unitBrief.minSpotLength,
          unitBrief.maxSpotLength,
          unitBrief.allowedLanguages,
        );
      },
      // GEOFENCE SITE - EXPORT ENTRIES
      async getGeofenceSiteExportEntries(geofenceGroupID) {
        if (this.unitsInGeofenceGroup == null) {
          await this.previewGeofenceGroupSites();
        }
        const geofenceSiteIDs = [...new Set(this.unitsInGeofenceGroup.map((x) => x.siteID))];
        const geofenceUnitIDs = this.unitsInGeofenceGroup.map((x) => x.unitID);
        if (this.isEditable) {
          return this.geofenceSiteExportEntriesForEditView(geofenceSiteIDs, geofenceUnitIDs);
        }
        return this.geofenceSiteExportEntriesForDetailsView(geofenceSiteIDs, geofenceUnitIDs, geofenceGroupID);
      },
      async geofenceSiteExportEntriesForEditView(geofenceSiteIDs, geofenceUnitIDs) {
        const siteExportEntries = [];
        const sitesBrief = await this.getSitesBriefUsingPost({ siteIDs: geofenceSiteIDs, unitIDs: geofenceUnitIDs });
        sitesBrief.forEach((site) => {
          const geofenceSiteModel = this.getGeofenceSiteModel(site);
          siteExportEntries.push(geofenceSiteModel);
        });
        return siteExportEntries;
      },
      async geofenceSiteExportEntriesForDetailsView(geofenceSiteIDs, geofenceUnitIDs, geofenceGroupID) {
        const uniqueSiteIDs = new Set();
        const geofenceById = new Map();

        const geofenceSiteMapping = await this.getGeofenceSiteMappingForSites({
          geofenceGroupID,
          siteIDs: geofenceSiteIDs,
        });

        this.geofenceGroup.geofences.forEach((geofence) => {
          geofenceById.set(geofence.id, geofence);
        });

        Object.values(geofenceSiteMapping).forEach((siteIDs) => {
          siteIDs.forEach((siteID) => {
            uniqueSiteIDs.add(siteID.site_id);
          });
        });

        const sitesBrief = await this.getSitesBriefUsingPost({
          siteIDs: Array.from(uniqueSiteIDs).flat(),
          unitIDs: geofenceUnitIDs,
        });

        const siteExportEntries = [];

        Object.entries(geofenceSiteMapping).forEach((entry) => {
          const [geofenceID, siteIDs] = entry;
          const geofence = geofenceById.get(Number(geofenceID));
          siteIDs.forEach((siteMappingEntry) => {
            const siteID = siteMappingEntry.site_id;
            const distanceFromCentroid = siteMappingEntry.distance_from_centroid;

            sitesBrief
              .filter((siteBrief) => siteBrief.siteID === siteID)
              .forEach((siteBrief) => {
                const geofenceSiteModel = this.getGeofenceSiteModel(siteBrief, geofence, distanceFromCentroid);
                siteExportEntries.push(geofenceSiteModel);
              });
          });
        });
        return siteExportEntries;
      },
      getGeofenceSiteModel(siteBrief, geofence, distanceFromCentroid) {
        return new GeofenceSiteModel(
          geofence?.name,
          geofence?.description,
          geofence?.lat,
          geofence?.lng,
          geofence?.tags,
          siteBrief.externalID,
          siteBrief.name,
          siteBrief.city,
          siteBrief.region,
          siteBrief.latitude,
          siteBrief.longitude,
          distanceFromCentroid,
          siteBrief.networkName,
          siteBrief.screenCount,
          siteBrief.physicalScreenCount,
        );
      },
      exportUnitsInGeofenceGroup() {
        this.$refs.sitesFileDownload.show();
      },
      exportGeofenceGroup() {
        this.$refs.geofenceFileDownload.show();
      },
      capitalize(text) {
        return capitalize(text);
      },
      getValidLatLong(input) {
        const coordinateRegex = /^(-?\d{1,2}[\.,]?\d{0,20})\,?\s{1,3}(-?\d{1,3}[\.,]?\d{0,20})$/;

        const match = input.trim().match(coordinateRegex);
        if (!match) {
          return false;
        }

        let [_, latitudeString, longitudeString] = match;

        // handle locale-specific numbers (some locales use ',' instead of '.' for decimals)
        latitudeString = latitudeString.replace(',', '.');
        longitudeString = longitudeString.replace(',', '.');

        const latitude = parseFloat(latitudeString);
        const longitude = parseFloat(longitudeString);

        if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) {
          return false;
        }

        return `${latitude}, ${longitude}`;
      },
      dispatchAction(action, geofence) {
        if (action.type === 'delete') {
          this.deleteGeofence(geofence);
        }
      },
      highlightGeofence(id) {
        [this.activeGeofence] = this.geofenceGroup.geofences.filter((x) => x.id === id);
      },
      activateGeofence(id, showPopup = true, zoomToGeofence = true) {
        this.isActiveGeofenceCircleRadiusPaneVisible = false;
        [this.activeGeofence] = this.geofenceGroup.geofences.filter((x) => x.id === id);
        if (this.activeGeofence == null) {
          return;
        }
        if (showPopup && this.isNotChina) {
          setTimeout(() => {
            const html = window.document.getElementById('place_popup_content').innerHTML;
            this.map.showPopup(html);

            const [popup] = window.document.getElementsByClassName('mapboxgl-popup');
            popup.className = `${popup.className} mapboxgl-popup visible`;
          }, 250);
        }
        if (zoomToGeofence && this.isNotChina) {
          this.map.zoomToGeofence(this.activeGeofence, false);
        }
        if (this.isEditable && this.activeGeofence.isPoint) {
          // display slider.
          if (this.canUseDynamicGeofences && this.activeGeofence.dynamicGeofences) {
            this.showRadius = false;
            this.showDynamicGeofence = true;
          }

          this.isActiveGeofenceCircleRadiusPaneVisible = true;
        }

        // Scroll automatically to the list item when a geofence point is clicked
        this.$refs?.geofenceList?.scrollToGeofenceListItem(id);
      },
      addPointToPolygonBeingDrawn(e) {
        this.polygonBeingDrawnCoordinates.push(e.lngLat);
      },
      async queryGeofencesBaidu() {
        if (this.placeSearchText == null) {
          return;
        }

        this.closeSlideShow();
        this.$refs.placeSearchTextInput.blur();
        this.showGeofenceWarningMessage = false;
        GlobalEventBus.$emit(GlobalEvents.loading);

        const searchEngine = new PlaceSearchEngineBaidu();
        let places = [];
        try {
          places = await searchEngine
            .searchPlaces(this.placeSearchText, this.geofenceGroup.usageID !== GeofenceGroupType.PROXIMITY)
            .catch(() => {
              GlobalEventBus.$emit(GlobalEvents.loaded);
              UserNotifications.error({
                title: capitalize(i18n.global.t('names.error', { n: 1 })),
                message: capitalize(i18n.global.t('messages.invalidSearch')),
              });
            });

          // It takes time to load the geofence when there are more than 2000 search results.
          if (places.length > 2000) {
            this.showGeofenceWarningMessage = true;
          }
          this.googleGeofenceQueryResult = places.map((x) => Geofence.fromBaiduApi(x));
        } catch (e) {
          this.googleGeofenceQueryResult = [];
        } finally {
          GlobalEventBus.$emit(GlobalEvents.loaded);
        }
        if (places.length > 0) {
          this.showGeofenceSearchResult();
        }
      },
      async queryGeofences2() {
        if (this.placeSearchText == null) {
          return;
        }
        this.closeSlideShow();
        this.$refs.placeSearchTextInput.blur();
        this.showGeofenceWarningMessage = false;
        this.isFetchingPlaces = true;

        //
        // Check if user is searching by coordinates
        //
        const searchCoordinates = this.getValidLatLong(this.placeSearchText);
        if (searchCoordinates) {
          this.placeSearchText = searchCoordinates;
        }

        //
        // Check if user is searching for a city / address
        //
        const bounds = this.map.getBounds();

        const searchInViewport =
          this.placeSearchText.indexOf(' in ') === -1 && this.placeSearchText.indexOf(' near ') === -1;

        const latLngBounds = searchInViewport
          ? new window.google.maps.LatLngBounds(
              new window.google.maps.LatLng(bounds.getSouth(), bounds.getWest()),
              new window.google.maps.LatLng(bounds.getNorth(), bounds.getEast()),
            )
          : undefined;
        const textSearchCallback = async (result, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const [firstResult] = result;
            if (
              result.length === 1 &&
              (firstResult.types.find((x) => x === 'route') !== undefined ||
                firstResult.types.find((x) => x === 'locality') !== undefined ||
                firstResult.types.find((x) => x === 'country') !== undefined ||
                firstResult.types.find((x) => x === 'political') !== undefined ||
                firstResult.types.find((x) => x === 'premise') !== undefined)
            ) {
              this.map.fitBounds([
                [
                  firstResult.geometry.viewport.getSouthWest().lng(),
                  firstResult.geometry.viewport.getSouthWest().lat(),
                ],
                [
                  firstResult.geometry.viewport.getNorthEast().lng(),
                  firstResult.geometry.viewport.getNorthEast().lat(),
                ],
              ]);

              this.isFetchingPlaces = false;
              GlobalEventBus.$emit(GlobalEvents.loaded);
              return;
            }
            //
            // Search places
            //
            const searchEngine = new PlaceSearchEngine();
            let places = [];
            try {
              places = await searchEngine.searchPlaces(
                this.placeSearchText,
                this.geofenceGroup.usageID !== GeofenceGroupType.PROXIMITY,
              );

              if (places.length > 10) {
                this.showGeofenceWarningMessage = true;
              }
              this.googleGeofenceQueryResult = places.map((x) => Geofence.fromHereApi(x));
            } catch (e) {
              UserNotifications.error({
                title: capitalize(i18n.global.t('names.error', { n: 1 })),
                message: capitalize(i18n.global.t('messages.invalidSearch')),
              });
              this.googleGeofenceQueryResult = [];
            } finally {
              this.isFetchingPlaces = false;
            }
            if (places.length > 0) {
              this.showGeofenceSearchResult();
            } else {
              this.searchPlacesUsingGoogleMaps();
            }
          } else {
            GlobalEventBus.$emit(GlobalEvents.loaded);
            this.isNoSearchResultsModalVisible = true;
            this.isFetchingPlaces = false;
          }
        };

        const service = new window.google.maps.places.PlacesService(window.document.createElement('div'));
        service.textSearch(
          {
            query: this.placeSearchText,
            bounds: latLngBounds,
          },
          textSearchCallback,
        );
      },
      searchPlacesUsingGoogleMaps() {
        if (this.placeSearchText === null || this.placeSearchText.trim() === '') {
          return;
        }

        this.$refs.placeSearchTextInput.blur();

        this.isRunningGeofenceQuery = true;

        setTimeout(() => {
          this.osmGeofenceQueryResult = [];
          this.googleGeofenceQueryResult = [];
          const bounds = this.map.getBounds();
          let runningSearches = 2;
          let zoomOnMapInsteadOfDisplayingSearchResultModal = false;

          const searchInViewport =
            this.placeSearchText.indexOf(' in ') === -1 && this.placeSearchText.indexOf(' near ') === -1;

          const latLngBounds = searchInViewport
            ? new window.google.maps.LatLngBounds(
                new window.google.maps.LatLng(bounds.getSouth(), bounds.getWest()),
                new window.google.maps.LatLng(bounds.getNorth(), bounds.getEast()),
              )
            : undefined;

          // Search the map within visible bounds.
          OpenStreetMapApi.instance.searchPlaces(
            this.placeSearchText,
            bounds.getSouth(),
            bounds.getNorth(),
            bounds.getWest(),
            bounds.getEast(),
            searchInViewport,
            (result) => {
              // If no result was found, query again without the bounds.
              if (result.length === 0) {
                runningSearches -= 1;
                if (runningSearches === 0) {
                  this.isRunningGeofenceQuery = false;
                  if (!zoomOnMapInsteadOfDisplayingSearchResultModal) {
                    this.showGeofenceSearchResult();
                  }
                }
              } else {
                const osmGeofenceQueryResult = [
                  ...result.map((x) =>
                    Geofence.fromOSMApi(x, this.geofenceGroup.usageID !== GeofenceGroupType.PROXIMITY),
                  ),
                ];
                this.osmGeofenceQueryResult = osmGeofenceQueryResult;

                runningSearches -= 1;
                if (runningSearches === 0) {
                  this.isRunningGeofenceQuery = false;
                  if (!zoomOnMapInsteadOfDisplayingSearchResultModal) {
                    this.showGeofenceSearchResult();
                  }
                }
              }
            },
            () => {
              runningSearches -= 1;
              if (runningSearches === 0) {
                this.isRunningGeofenceQuery = false;
                if (!zoomOnMapInsteadOfDisplayingSearchResultModal) {
                  this.showGeofenceSearchResult();
                }
              }
            },
          );

          const textSearchCallback = (result, status, pagination) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              const [firstResult] = result;
              if (
                result.length === 1 &&
                (firstResult.types.find((x) => x === 'route') !== undefined ||
                  firstResult.types.find((x) => x === 'locality') !== undefined ||
                  firstResult.types.find((x) => x === 'country') !== undefined ||
                  firstResult.types.find((x) => x === 'political') !== undefined)
              ) {
                zoomOnMapInsteadOfDisplayingSearchResultModal = true;
                this.map.fitBounds([
                  [
                    firstResult.geometry.viewport.getSouthWest().lng(),
                    firstResult.geometry.viewport.getSouthWest().lat(),
                  ],
                  [
                    firstResult.geometry.viewport.getNorthEast().lng(),
                    firstResult.geometry.viewport.getNorthEast().lat(),
                  ],
                ]);
              }

              this.googleGeofenceQueryResult = [
                ...this.googleGeofenceQueryResult,
                ...result.map((x) => Geofence.fromGoogleApi(x)),
              ];

              if (pagination.hasNextPage) {
                pagination.nextPage();
                return;
              }
            }
            runningSearches -= 1;
            if (runningSearches === 0) {
              this.isRunningGeofenceQuery = false;
              if (!zoomOnMapInsteadOfDisplayingSearchResultModal) {
                this.showGeofenceSearchResult();
              }
            }
          };

          const service = new window.google.maps.places.PlacesService(window.document.createElement('div'));
          service.textSearch(
            {
              query: this.placeSearchText,
              bounds: latLngBounds,
            },
            textSearchCallback,
          );
        }, 100);
      },
      showGeofenceSearchResult() {
        this.showLocalLoader = true;
        setTimeout(() => {
          this.isGeofenceListSelectionModalVisible = true;
        }, 1000);
      },
      hideGeofenceSearchResult() {
        this.isGeofenceListSelectionModalVisible = false;
      },
      selectGeofencesSearchResultModalConfirmed(data) {
        data.places.forEach((x) => x.updateBoundingBox());
        this.addGeofencesToMap(data.places, true);
        this.hideGeofenceSearchResult();
      },
      selectGeofencesSearchResultModalCancelled() {
        this.hideGeofenceSearchResult();
      },
      updateGeofencePolygonDataSource() {
        const geofencePolygonsLayerData = this.map.getSource('place_polygons_source');
        if (geofencePolygonsLayerData === undefined) {
          return;
        }
        const features = this.geofenceGroup.geofences.map((x) => x.feature);
        geofencePolygonsLayerData.setData({
          type: 'FeatureCollection',
          features,
        });

        if (this.areGeofenceBoundingBoxesVisible) {
          const bboxFeatures = this.geofenceGroup.geofences.map((x) => x.boundingBoxFeature);
          this.map.getSource('place_bbox_source').setData({
            type: 'FeatureCollection',
            features: bboxFeatures,
          });
        }
      },
      selectGeofence(geofence) {
        this.addGeofencesToMap([geofence]);
        const index = this.disabledGeofences.findIndex((g) => geofence.id === g.id);
        if (index !== -1) {
          this.disabledGeofences.splice(index, 1);
        }
      },
      unselectGeofence(geofence) {
        this.disabledGeofences.push(geofence);
        this.deleteGeofence(geofence);
      },
      addGeofencesToMap(geofences, fitBounds = true) {
        if (geofences == null || geofences.length === 0) {
          return;
        }

        const newGeofences = geofences.filter((x) => this.geofenceGroup.geofences.filter((y) => y === x).length === 0);

        if (newGeofences.length > 0) {
          this.updateGeofences([...this.geofenceGroup.geofences, ...newGeofences]);
        }

        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        }

        if (fitBounds && this.isNotChina) {
          this.fitAllGeofencesIntoView();
        }
      },
      fitAllGeofencesIntoView() {
        if (this.isNotChina) {
          const { geofences } = this.geofenceGroup;
          if (geofences.length === 0) {
            return;
          }

          const minLat = Math.min(...geofences.map((x) => parseFloat(x.boundsSwLat)));
          const maxLat = Math.max(...geofences.map((x) => parseFloat(x.boundsNeLat)));
          const minLng = Math.min(...geofences.map((x) => parseFloat(x.boundsSwLng)));
          const maxLng = Math.max(...geofences.map((x) => parseFloat(x.boundsNeLng)));
          const marginH = getContainerWidth('map-container') / 5;
          const marginV = getContainerHeight('map-container') / 5;
          this.map.fitBounds(
            [
              [minLng, minLat],
              [maxLng, maxLat],
            ],
            {
              padding: {
                left: marginH,
                right: marginH,
                top: marginV,
                bottom: marginV,
              },
              duration: 0,
            },
          );
        } else {
          this.map.shapesBoundingBox();
        }
      },
      zoomToGeofence(geofence, fromList) {
        if (
          this.lastGeofenceMenuClickedAt !== undefined &&
          DateTime.local().diff(this.lastGeofenceMenuClickedAt) < 100
        ) {
          return;
        }

        if (this.isNotChina) {
          this.map.zoomToGeofence(geofence);
        }

        this.isActiveGeofenceCircleRadiusPaneVisible = false;
        this.showDynamicGeofence = false;
        this.showRadius = true;
        this.activeGeofence = geofence;

        if (!fromList) {
          if (this.$refs.geofenceListRecycleScroller != null) {
            this.$refs.geofenceListRecycleScroller.scrollToItem(
              this.geofenceGroup.geofences.indexOf(this.activeGeofence),
            );
          }
        }
      },
      startSlideShow() {
        this.map.startSlideShow();
        this.isSlideShowRunning = true;
      },
      stopSlideShow() {
        this.map.stopSlideShow();
        this.isSlideShowRunning = false;
      },
      closeSlideShow() {
        this.unitsInGeofenceGroup?.splice(0, this.unitsInGeofenceGroup.length);
      },
      handleNewPolygonCreationMapbox(polygon, isPolygonFrom3dBuilding) {
        this.isNewlyDrawnPolygonFrom3dBuilding = isPolygonFrom3dBuilding;
        [this.newlyDrawnPolygon] = polygon.features;
        this.newlyDrawnPolygonHeight = polygon.height !== undefined ? polygon.height : 10;
        const coordinates = this.newlyDrawnPolygon.geometry.coordinates[0];
        //
        // Look for points within polygon
        //
        const pointGeofences = this.geofenceGroup.geofences.filter((x) => x.isPoint);
        this.pointGeofencesInNewlyDrawnPolygon = pointGeofences.filter((x) =>
          isPointInsidePolygon([x.lng, x.lat], coordinates),
        );

        //
        // Look for points close by
        //
        const polygonCentroid = new Centroid(
          coordinates.map((x) => {
            return { x: x[0], y: x[1] };
          }),
        ).centroid();
        const WITHIN_KM = 0.1;
        const hasCoordinateWithinVicinity = (lat, lng, geometry) => {
          const flattened =
            geometry.type === 'MultiPolygon'
              ? geometry.coordinates.flat().reduce((mem, x) => (mem = [...mem, ...x]), [])
              : geometry.coordinates.flat();
          return flattened.filter((x) => getDistanceFromLatLonInKm(lat, lng, x[1], x[0]) < WITHIN_KM).length > 0;
        };
        this.pointGeofencesNearNewlyDrawnPolygon = this.geofenceGroup.geofences
          .filter(
            (x) =>
              hasCoordinateWithinVicinity(polygonCentroid.y, polygonCentroid.x, x.geometry) &&
              this.pointGeofencesInNewlyDrawnPolygon.indexOf(x) === -1,
          )
          .map((x) => {
            return {
              distanceInMeters: Math.round(
                getDistanceFromLatLonInKm(x.lat, x.lng, polygonCentroid.y, polygonCentroid.x) * 1000,
              ),
              geofence: x,
            };
          });

        //
        // Display list of all point geofences for linking and allow creation of new geofence
        //
        this.isGeofenceFromPolygonCreationModalVisible = true;
      },
      handleNewPolygonCreationBaidu(polygon, placesNearByNewPolygon) {
        this.newlyDrawnPolygonBaidu = polygon;
        const coordinates = polygon.coordinates[0][0];
        //
        // Look for points within polygon
        //
        const pointGeofences = this.geofenceGroup.geofences.filter((x) => x.isPoint);
        this.pointGeofencesInNewlyDrawnPolygon = pointGeofences.filter((x) =>
          isPointInsidePolygon([x.lng, x.lat], coordinates),
        );

        //
        // Look for points close by
        //
        const polygonCentroid = new Centroid(
          coordinates.map((x) => {
            return { x: x[0], y: x[1] };
          }),
        ).centroid();
        const WITHIN_KM = 0.1;
        const hasCoordinateWithinVicinity = (lat, lng, geometry) => {
          const flattened =
            geometry.type === 'MultiPolygon'
              ? geometry.coordinates.flat().reduce((mem, x) => (mem = [...mem, ...x]), [])
              : geometry.coordinates.flat();
          return flattened.filter((x) => getDistanceFromLatLonInKm(lat, lng, x[1], x[0]) < WITHIN_KM).length > 0;
        };
        this.pointGeofencesNearNewlyDrawnPolygon = this.geofenceGroup.geofences
          .filter(
            (x) =>
              hasCoordinateWithinVicinity(polygonCentroid.y, polygonCentroid.x, x.geometry) &&
              this.pointGeofencesInNewlyDrawnPolygon.indexOf(x) === -1,
          )
          .map((x) => {
            return {
              distanceInMeters: Math.round(
                getDistanceFromLatLonInKm(x.lat, x.lng, polygonCentroid.y, polygonCentroid.x) * 1000,
              ),
              geofence: x,
            };
          });

        this.placesNearByNewPolygon = placesNearByNewPolygon != null ? placesNearByNewPolygon.Hr : [];

        //
        // Display list of all point geofences for linking and allow creation of new geofence
        //
        this.isGeofenceFromPolygonCreationModalVisible = true;
      },
      handleNewPointCreation(point, results) {
        this.lastPointCoordinate = point;
        this.isGeofenceFromCoordinateCreationModalVisible = true;
        this.placesNearByNewPoint = results != null ? results.Hr : [];
      },
      handlePolygonUpdate(e) {
        const geoJson = e.features[0].geometry;
        const [geofence] = this.geofenceGroup.geofences.filter(
          (x) => `${e.features[0].id}`.localeCompare(`${x.mapboxDrawID}`) === 0,
        );
        if (geofence.isPoint) {
          const geometry = turf.multiPolygon(e.features[0].geometry.coordinates);
          const centroid = turfCentroid(geometry);
          this.updateGeofenceLat({ geofence, value: centroid.coordinates[1] });
          this.updateGeofenceLng({ geofence, value: centroid.coordinates[0] });
        } else {
          this.updateGeofenceGeoJson({ geofence, value: geoJson });
        }
        this.$emit('geofenceUpdated', geofence);
        this.map.updateGeofenceDataSources();
      },
      cancelGeofenceCreationFromPolygon() {
        this.isGeofenceFromPolygonCreationModalVisible = false;
        if (this.isNotChina) {
          this.map.deleteGeofence(this.newlyDrawnPolygon.id);
        } else {
          this.clearNewPolygon = true;
        }
      },
      confirmGeofenceCreationFromPolygon(data) {
        this.isActiveGeofenceCircleRadiusPaneVisible = false;
        this.isGeofenceFromPolygonCreationModalVisible = false;

        const geoJson = data.polygon.geometry;
        let polygonCoordinates = null;
        let centroid = null;
        if (this.isNotChina) {
          [polygonCoordinates] = data.polygon.geometry.coordinates;
          centroid = turfCentroid(data.polygon.geometry);
        } else {
          [polygonCoordinates] = data.polygon.coordinates;
          centroid = turfCentroid(data.polygon);
        }
        const lngs = polygonCoordinates.map((x) => x[0]);
        const lats = polygonCoordinates.map((x) => x[1]);
        const swLng = Math.min(...lngs);
        const swLat = Math.min(...lats);
        const neLng = Math.max(...lngs);
        const neLat = Math.max(...lats);
        let geofence =
          data.geofence !== null && this.geofenceGroup.geofences.filter((x) => x.id === data.geofence.id).length > 0
            ? this.geofenceGroup.geofences.filter((x) => x.id === data.geofence.id)[0]
            : null;
        if (geofence === null) {
          if (data.placeCandidate !== null && data.placeCandidate !== undefined) {
            geofence = Geofence.fromObject(
              {
                id:
                  (this.isNotChina ? data.placeCandidate.id : data.placeCandidate.uid) || data.placeCandidate.place_id,
                geofenceGroupID: this.geofenceGroup.id,
                name: this.isNotChina ? data.placeCandidate.name : data.placeCandidate.title,
                description: this.isNotChina ? data.placeCandidate.vicinity : data.placeCandidate.address,
                lat: centroid.geometry.coordinates[1],
                lng: centroid.geometry.coordinates[0],
                boundsSwLng: swLng,
                boundsSwLat: swLat,
                boundsNeLng: neLng,
                boundsNeLat: neLat,
                placeSearchProvider: 'Google',
                geoJson,
                mapboxDrawID: this.isNotChina ? this.newlyDrawnPolygon.id : null,
                extrusion: this.isNotChina ? this.newlyDrawnPolygonHeight : null,
                radius: this.circleRadiusInKilometers,
                isPoint: geoJson === null,
              },
              null,
            );
          } else {
            geofence = Geofence.fromObject(
              {
                id: data.customGeofenceID,
                geofenceGroupID: this.geofenceGroup.id,
                name: data.customGeofenceName,
                description: data.customGeofenceDescription,
                geoJson,
                lat: centroid.geometry.coordinates[1],
                lng: centroid.geometry.coordinates[0],
                boundsSwLng: swLng,
                boundsSwLat: swLat,
                boundsNeLng: neLng,
                boundsNeLat: neLat,
                mapboxDrawID: this.isNotChina ? this.newlyDrawnPolygon.id : null,
                extrusion: this.isNotChina ? this.newlyDrawnPolygonHeight : null,
                radius: this.circleRadiusInKilometers,
                isPoint: geoJson === null,
              },
              null,
            );
          }
          this.clearNewPolygon = true;
          this.updateGeofenceGroupGeofences({
            geofenceGroup: this.geofenceGroup,
            value: [...this.geofenceGroup.geofences, geofence],
          });
        } else if (data.mode === 'link') {
          if (this.isNotChina) {
            this.deleteGeofence(geofence);
            this.updateGeofenceMapboxDrawID({ geofence, value: this.newlyDrawnPolygon.id });
            this.updateGeofenceGeoJson({ geofence, value: geoJson });
            this.updateGeofenceIsPoint({ geofence, value: false });
            this.updateGeofenceExtrusion({ geofence, value: this.newlyDrawnPolygonHeight });
          } else {
            this.clearNewPolygon = true;
            this.updateGeofenceMapboxDrawID({ geofence, value: this.newlyDrawnPolygonBaidu.id });
            this.updateGeofenceGeoJson({ geofence, value: geoJson });
            this.updateGeofenceIsPoint({ geofence, value: false });
          }
          // Make sure we flag the geofence group as modified so that geofences are saved.
          this.updateGeofenceGroupGeofences({
            geofenceGroup: this.geofenceGroup,
            value: [...this.geofenceGroup.geofences.filter((x) => x.id !== geofence.id), geofence],
          });
        } else if (data.mode === 'add') {
          const mergedGeoJson = JSON.stringify({
            type: 'MultiPolygon',
            coordinates:
              geofence.geometry.type === 'Polygon'
                ? [geofence.geometry.coordinates, data.polygon.geometry.coordinates]
                : [...geofence.geometry.coordinates, data.polygon.geometry.coordinates],
          });
          this.updateGeofenceGeoJson({ geofence, value: mergedGeoJson });
          this.clearNewPolygon = true;
        }

        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        }

        //
        // This duplicates polygons
        //
        // if (this.isNewlyDrawnPolygonFrom3dBuilding && this.isNotChina) {
        //   this.addGeofencesToMap([geofence], false);
        // }

        setTimeout(() => {
          this.activeGeofence = null;
          this.activeGeofence = geofence;
        }, 100);
      },
      confirmGeofenceCreationFromCoordinate(data) {
        this.isGeofenceFromCoordinateCreationModalVisible = false;

        let geofence = null;
        if (data.placeCandidate !== null && data.placeCandidate !== undefined) {
          geofence = Geofence.fromObject({
            id: (this.isNotChina ? data.placeCandidate.id : data.placeCandidate.uid) || data.placeCandidate.place_id,
            geofenceGroupID: this.geofenceGroup.id,
            name: this.isNotChina ? data.placeCandidate.name : data.placeCandidate.title,
            description: this.isNotChina ? data.placeCandidate.vicinity : data.placeCandidate.address,
            lat: this.lastPointCoordinate.lat,
            lng: this.lastPointCoordinate.lng,
            boundsSwLng: this.lastPointCoordinate.lng,
            boundsSwLat: this.lastPointCoordinate.lat,
            boundsNeLng: this.lastPointCoordinate.lng,
            boundsNeLat: this.lastPointCoordinate.lat,
            placeSearchJson: JSON.stringify(data.placeCandidate),
            placeSearchProvider: this.isNotChina ? 'Google' : 'Baidu',
            geoJson: null,
            mapboxDrawID: null,
            extrusion: 3.03,
            radius: data.radius,
            radiusUnit: data.radiusUnit,
            radiusInUnit: data.radiusInUnit,
            isPoint: true,
          });
        } else {
          geofence = Geofence.fromObject({
            id: data.customGeofenceID,
            geofenceGroupID: this.geofenceGroup.id,
            name: data.customGeofenceName,
            description: data.customGeofenceDescription,
            geoJson: null,
            lat: this.lastPointCoordinate.lat,
            lng: this.lastPointCoordinate.lng,
            boundsSwLng: this.lastPointCoordinate.lng,
            boundsSwLat: this.lastPointCoordinate.lat,
            boundsNeLng: this.lastPointCoordinate.lng,
            boundsNeLat: this.lastPointCoordinate.lat,
            mapboxDrawID: null,
            extrusion: 3.03,
            radius: data.radius,
            radiusUnit: data.radiusUnit,
            radiusInUnit: data.radiusInUnit,
            isPoint: true,
          });

          geofence.updateBoundingBox();
        }

        this.updateGeofenceGroupGeofences({
          geofenceGroup: this.geofenceGroup,
          value: [...this.geofenceGroup.geofences, geofence],
        });

        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        }
      },
      cancelGeofenceCreationFromCoordinate() {
        this.isGeofenceFromCoordinateCreationModalVisible = false;
      },
      confirmGeofenceCreationFromGeneric(geofences) {
        geofences.forEach((g) => g.updateBoundingBox());
        this.addGeofencesToMap(geofences, true);
        this.isGenericGeofenceSearchModalVisible = false;
      },
      cancelGeofenceCreationFromGeneric() {
        this.isGenericGeofenceSearchModalVisible = false;
      },
      deleteGeofence(geofence) {
        this.closeSlideShow();
        if (geofence.mapboxDrawID !== null && this.isNotChina) {
          this.map.deleteGeofence(geofence.mapboxDrawID);
        }
        this.updateGeofences(this.geofenceGroup.geofences.filter((x) => x.id !== geofence.id));
        this.activeGeofence = null;
      },
      deleteAllGeofences() {
        if (this.isNotChina) {
          this.geofenceGroup.geofences.forEach((g) => {
            this.unselectGeofence(g);
          });
        }
        GlobalEventBus.$emit(GlobalEvents.clearTooltips);
      },
      restoreAllGeofences() {
        this.addGeofencesToMap([...this.disabledGeofences]);
        this.disabledGeofences = [];
      },
      showCSVUploadModal() {
        this.$refs.geofenceFileUpload.show();
      },
      updateGeofences(geofences) {
        this.updateGeofenceGroupGeofences({
          geofenceGroup: this.geofenceGroup,
          value: geofences,
        });
        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        } else {
          this.map.updatePointsAndPolygons();
        }

        setTimeout(this.updateGeofenceListRecycleScrollerHeight, 200);
      },
      updateGeofenceListRecycleScrollerHeight() {
        const container = document.getElementById('geofence_list_container');
        if (container == null) {
          return;
        }
        const style = `height: ${container.clientHeight}px;`;
        const geofenceListScroller = document.getElementById('geofence_list_recycle_scroller');
        if (geofenceListScroller != null) {
          geofenceListScroller.style = style;
        }
      },
      init() {
        setTimeout(() => {
          window.onblur = () => {
            if (this.isSlideShowRunning) {
              this.stopSlideShow();
            }
          };

          window.addEventListener('resize', () => {
            this.updateGeofenceListRecycleScrollerHeight();
          });

          if (this.isNotChina) {
            loadGooglePlacesApi();
          }

          this.updateGeofenceListRecycleScrollerHeight();

          // Fixes the map whenever the navbar is toggled.
          GlobalEventBus.$on(GlobalEvents.navbarToggled, () => {
            setTimeout(() => {
              window.dispatchEvent(new window.Event('resize'));
            }, 500);
          });
        }, 250);
      },
      handleActiveGeofenceCircleRadiusDistanceChange(radiusInMeters, radiusUnit, radiusInUnit) {
        const radius = radiusInMeters / 1000;
        if (this.activeGeofence === null || this.activeGeofence.radius === radius) {
          return;
        }
        this.updateAllGeofenceRadiusValues(this.activeGeofence, radius, radiusUnit, radiusInUnit);
        this.updateGeofence(this.activeGeofence);
        this.activeGeofence.updateBoundingBox();
        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        } else {
          this.map.updatePointsAndPolygons();
        }
      },
      updateGeofence(geofence) {
        const updatedGeofences = [...this.geofenceGroup.geofences].map((x) =>
          Geofence.fromObject(x.id === geofence.id ? geofence : x, null),
        );

        this.updateGeofenceGroupGeofences({
          geofenceGroup: this.geofenceGroup,
          value: updatedGeofences,
        });
      },
      onDynamicGeofenceUpdated(geofence, skipRadiusUpdate = false) {
        if (skipRadiusUpdate === false) {
          this.updateAllGeofenceRadiusValues(this.activeGeofence, 0, DistanceUnit.METER, 0);
        }

        this.updateGeofence(geofence);

        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        } else {
          this.map.updatePointsAndPolygons();
        }
      },
      applyActiveGeofenceRadiusToAllGeofences() {
        if (this.showDynamicGeofence) {
          this.applyDynamicGeofencesToAllGeofences();
        } else {
          this.changeRadiusForAllGeofences(
            this.activeGeofence.radius,
            this.activeGeofence.radiusUnit,
            this.activeGeofence.radiusInUnit,
          );
        }
      },
      async applyDynamicGeofencesToAllGeofences() {
        this.clearRadius(this.geofenceGroup.geofences);
        // remove previous geofences before applying the same geofences to all
        this.geofenceGroup?.geofences.forEach((geofence) => {
          this.map.deleteGeofence(geofence?.mapboxDrawID);
        });
        await this.$refs.dynamicGeofences.applyToAllGeofences(this.geofenceGroup.geofences);
      },
      clearRadius(geofences) {
        geofences.forEach((geofence) => {
          this.updateAllGeofenceRadiusValues(geofence, 0, DistanceUnit.METER, 0);
          const ids = this.map.addGeofence(geofence.feature);
          this.updateGeofenceMapboxDrawID({ geofence, value: ids[0] });
          this.map.updateGeofenceDataSources();
        });
      },
      changeRadiusForAllGeofences(radius, radiusUnit, radiusInUnit) {
        const activeGeofenceID = this.activeGeofence.id;

        const updatedGeofences = this.geofenceGroup.geofences
          .filter((x) => x.isPoint)
          .map((x) => {
            const bb = new GeoPoint(x.lat, x.lng).boundingCoordinates(radius, null, true);
            return new Geofence(
              x.id,
              x.geofenceGroupID,
              x.name,
              x.description,
              `{ "isPoint": true, "radius": ${radius} , "radiusUnit": "${radiusUnit}" , "radiusInUnit": ${radiusInUnit} }`,
              x.lat,
              x.lng,
              bb[0].latitude(),
              bb[0].longitude(),
              bb[1].latitude(),
              bb[1].longitude(),
              null,
              null,
              null,
              x.createdOnUtc,
            );
          });
        this.updateGeofences([...this.geofenceGroup.geofences.filter((x) => !x.isPoint), ...updatedGeofences]);
        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        } else {
          this.map.updatePointsAndPolygons();
        }

        this.activateGeofence(activeGeofenceID, false, false);
      },
      convertPointGeofenceToPolygonGeofence() {
        const { activeGeofence } = this;
        this.map.setCenter([activeGeofence.lng, activeGeofence.lat]);

        const x = window.document.querySelector('.map-container').offsetWidth / 2;
        const y = window.document.querySelector('.map-container').offsetHeight / 2;

        this.map.fireClick({
          point: [x + 5, y + 5],
        });

        this.isConvertingPointGeofenceToPolygonGeofence = true;
        if (this.lastClicked3DBuildingEvent != null) {
          this.map.fireClick(this.lastClicked3DBuildingEvent);
        } else {
          const geoJSON = JSON.stringify({
            type: 'Polygon',
            coordinates: [
              [
                [activeGeofence.boundsSwLng, activeGeofence.boundsSwLat],
                [activeGeofence.boundsSwLng, activeGeofence.boundsNeLat],
                [activeGeofence.boundsNeLng, activeGeofence.boundsNeLat],
                [activeGeofence.boundsNeLng, activeGeofence.boundsSwLat],
                [activeGeofence.boundsSwLng, activeGeofence.boundsSwLat],
              ],
            ],
          });
          this.updateGeofenceIsPoint({ geofence: activeGeofence, value: false });
          this.updateAllGeofenceRadiusValues(activeGeofence, undefined, null, null);
          this.updateGeofenceGeoJson({ geofence: activeGeofence, value: geoJSON });

          const ids = this.map.addGeofence(activeGeofence.feature);
          this.updateGeofenceMapboxDrawID({ geofence: activeGeofence, value: ids[0] });

          this.map.updateGeofenceDataSources();

          this.isActiveGeofenceCircleRadiusPaneVisible = false;
        }
        setTimeout(() => {
          this.isConvertingPointGeofenceToPolygonGeofence = false;
        }, 100);
        this.$emit('geofenceUpdated', activeGeofence);
      },
      convertToDynamicGeofence() {
        // Remove the radius drawn on the map before showing the DynamicGeofences component
        this.updateAllGeofenceRadiusValues(this.activeGeofence, 0, DistanceUnit.METER, 0);
        this.showDynamicGeofence = true;
        this.showRadius = false;
      },
      convertToRadius() {
        // remove the dynamic geofences drawn on the map before showing the radius component
        if (this.activeGeofence.dynamicGeofences || this.activeGeofence.radius === 0) {
          this.activeGeofence.dynamicGeofences = null;
          this.activeGeofence.geoJson = null;
          this.onDynamicGeofenceUpdated(this.activeGeofence, true);
        }

        this.updateAllGeofenceRadiusValues(
          this.activeGeofence,
          this.activeGeofence.radius || 0.01,
          DistanceUnit.METER,
          this.activeGeofence.radius || 0.01,
        );
        this.updateGeofence(this.activeGeofence);

        if (this.isNotChina) {
          this.map.updateGeofenceDataSources();
        } else {
          this.map.updatePointsAndPolygons();
        }

        this.showRadius = true;
        this.showDynamicGeofence = false;
      },
      updateAllGeofenceRadiusValues(geofence, radius, radiusUnit, radiusInUnit) {
        this.updateGeofenceRadius({ geofence: geofence, value: radius });
        this.updateGeofenceRadiusUnit({ geofence: geofence, value: radiusUnit });
        this.updateGeofenceRadiusInUnit({ geofence: geofence, value: radiusInUnit });
      },
      appropriateToolTip(currency) {
        return GeofencesUtils.appropriateToolTip(currency);
      },
      appropriateSearchPlaceholder(currency) {
        return GeofencesUtils.appropriateSearchPlaceholder(currency);
      },
    },
    watch: {
      unitsInGeofenceGroup() {
        if (this.map != null) {
          setTimeout(() => {
            this.map.updateInventoryDataSource();
          }, 100);
        }
      },
      activeGeofence() {
        if (this.activeGeofence == null) {
          this.isActiveGeofenceCircleRadiusPaneVisible = false;
        } else if (
          this.isEditable &&
          this.isNotChina &&
          !this.activeGeofence.isPoint &&
          this.activeGeofence.mapboxDrawID == null
        ) {
          //
          // Add polygons to MapboxDraw
          //
          const ids = this.map.addGeofence(this.activeGeofence.feature);
          this.updateGeofenceMapboxDrawID({ geofence: this.activeGeofence, value: ids[0] });
        }
        if (this.isNotChina) {
          this.map.updatePulseMarkerPosition(this.activeGeofence);
        }
      },
      geofenceGroup(val) {
        if (val !== null) {
          this.init();
        }
      },
      isRunningGeofenceQuery(newValue) {
        if (newValue) {
          GlobalEventBus.$emit(GlobalEvents.loading);
        } else {
          GlobalEventBus.$emit(GlobalEvents.loaded);
        }
      },
      circleRadiusInKilometers(val) {
        this.applyActiveGeofenceRadiusToAllGeofences(val);
      },
    },
    async beforeMount() {
      await this.getGenericGeofenceGroupTypeCountries({
        queryParams: QueryParams.for({
          filterCollection: new FilterCollection([
            new Filter('country_code', this.organization.countries, ComparisonOperator.IN),
          ]),
        }),
      });
    },
    async mounted() {
      loadGooglePlacesApi();
      this.init();
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss">
  @use '@/styles/variables' as *;

  #app {
    #geofences-list-and-map {
      .default-circle-radius {
        font-size: 0.9em;
        /*padding: 0.6rem 1rem;*/
        background: rgba(0, 0, 0, 0.025);
        border-top: solid 0.1rem rgba(0, 0, 0, 0.05);

        display: flex;
        align-items: center;

        .title {
          flex-grow: 1;
          font-weight: 500;
        }

        input {
          margin-right: 0.6rem;
          border: solid 0.1rem #ddd;
          border-radius: 0.4rem;
          padding: 0.3rem;
        }
      }

      #geofence_listmapInternal_pane {
        display: flex;
        max-height: 100%;
        overflow: auto;
      }

      #geofence_list_container {
        flex-grow: 1;
        max-height: 100%;
      }

      .pane-and-map {
        display: flex;
        flex-grow: 1;
        max-height: 100%;

        .map-container {
          box-shadow: var(--panesShadow);

          flex-grow: 1;
          margin: 0;
          display: flex;
          overflow: hidden;
          position: relative;

          .map {
            flex-grow: 1;
            margin: 0;
            width: 100%;
            height: 100%;
          }

          .mapboxgl-popup {
            transition:
              opacity 0.25s ease-in-out,
              margin-top 0.25s ease-in-out;
            opacity: 0.1;
            margin-top: -50px;

            &.visible {
              transition:
                opacity 0.25s ease-in-out,
                margin-top 0.25s ease-out;
              opacity: 1;
              margin-top: 0px;
            }
          }

          .radius-map-pane {
            position: absolute;
            bottom: 1.6rem;
            width: 50%;
            min-width: 45rem;
            left: 50%;
            margin-left: -25%;
            padding: 1.6rem;
            border-radius: 0.6rem;
            background: #fff;
            box-shadow: $small-shadow;
            transition:
              opacity 0.25s ease-in-out,
              margin-top 0.25s ease-out;
            opacity: 0;
            pointer-events: none;
            margin-top: -50px;
            display: flex;
            flex-direction: column;

            &.visible {
              transition:
                opacity 0.25s ease-in-out,
                margin-top 0.25s ease-out;
              opacity: 1;
              margin-top: 0px;
              pointer-events: all;
            }

            h3 {
              display: flex;
              align-items: center;

              span {
                display: flex;
                opacity: 30%;
                margin-left: 0.5rem;
              }
            }

            a {
              cursor: pointer;
              display: flex;
              align-items: center;

              svg {
                width: 1.2rem;
                position: relative;
                top: 2px;
                margin-right: 4px;
                fill: var(--actionsColor);
                stroke: var(--actionsColor);
              }

              span {
                display: flex;
                align-items: center;

                small {
                  display: flex;
                }
              }
            }
          }
        }

        .map-panes {
          display: flex;
          flex-basis: 32rem;
          padding-right: 0.8rem;

          .map-panes-left {
            display: flex;
            flex-direction: column;
            pointer-events: none;
            margin: 0;
            flex-grow: 1;
            max-width: 34rem;

            .map-pane {
              background: #fff;

              box-shadow: var(--panesShadow);
              background: var(--panesBackgroundColor);

              pointer-events: auto;
              margin-top: 0.8rem;
              display: flex;
              flex-direction: column;

              &.fill {
                flex-grow: 1;
              }

              &:first-of-type {
                margin-top: 0;
              }

              &.map-pane-search {
                flex-shrink: 0;
                height: unset;
                flex-basis: unset;
              }

              .map-pane-header {
                background-color: var(--paneHeaderBackgroundColor);

                font-weight: 700;
                border-bottom: solid 0.1rem $borders-light;
                display: flex;
                flex-direction: column;
                flex-shrink: 0;
                box-shadow: 0 0.1rem 0 rgba(0, 0, 0, 0.05);

                > div {
                  display: flex;
                  padding: 0.8rem 0.8rem 0.8rem 1.6rem;
                }

                span {
                  flex-grow: 1;
                }

                .actions {
                  display: flex;
                  align-items: center;

                  .btn {
                    margin-left: 0.3rem;

                    &:first-of-type {
                      margin-left: 0;
                    }
                  }
                }
              }

              .map-pane-content {
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;

                &.pad {
                  padding: 0.6rem;
                }
              }
            }
          }
        }
      }

      .search-input-pane {
        display: flex;
        flex-direction: row;

        form {
          display: flex;
          flex-grow: 1;
        }

        .form-control.input {
          flex-grow: 1;
        }

        .map-search-tooltip {
          background: var(--info);
          color: var(--infoReverse);

          position: absolute;
          margin-left: 34rem;
          margin-top: -2rem;
          margin-right: 3rem;
          padding: 2.4rem;
          z-index: 1;
          box-shadow: $shadow;

          ul {
            padding-left: 2rem;
          }

          .callout {
            position: absolute;
            left: -2.8rem;

            svg {
              height: 3.2rem;
              transform: rotate(180deg);

              fill: var(--info);
            }
          }
        }
      }

      .import-postal-codes {
        margin-left: 0.6rem;
        margin-top: 0.6rem;

        svg {
          width: 1.2rem;
          height: 1.2rem;

          fill: var(--secondaryColor);
          stroke: var(--secondaryColor);
        }
      }

      .place-popup-content {
        background-color: #fff;
        display: flex;
        align-items: center;
        max-width: 40rem;
        font-size: 1.2rem;

        svg {
          width: 3.2rem;
          margin-right: 1.2rem;
        }

        .name-and-description {
          display: flex;
          flex-direction: column;
          line-height: initial;

          strong {
            font-size: 1.2em;
            margin-bottom: 0.6rem;
          }

          .vue-slider-component {
            width: 20rem !important;
          }
        }
      }

      .download-screens-pane {
        box-shadow: var(--panesShadow);

        background-color: #fff;
        position: absolute;
        top: 0.6rem;
        left: 0.6rem;
        opacity: 1;
        margin: auto;
        z-index: 1;
        padding: 1.2rem 1.2rem 0.8rem;
        transition: all 0.5s $bezier-ease-out;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-right: 5rem;

        &.hidden {
          left: -100rem;
          opacity: 0;
          transition: all 0.5s $bezier-ease-out;
        }

        .btn-default {
          margin-left: 1rem;
          font-size: 2.4rem;
          padding: 1px 10px;
          font-weight: 100;
        }
      }

      .slideshow-active-geofence-pane {
        box-shadow: var(--panesShadow);

        background-color: #fff;
        position: absolute;
        top: 3.2rem;
        left: 3.2rem;
        opacity: 1;
        margin: auto;
        z-index: 1;
        padding: 1.2rem 2rem;
        transition: all 0.5s $bezier-ease-out;
        display: flex;
        align-items: center;

        &.hidden {
          left: -100rem;
          opacity: 0;
          transition: all 0.5s $bezier-ease-out;
        }

        svg {
          height: 3.2rem;
          margin-right: 1.2rem;
        }

        .name-and-description {
          display: flex;
          flex-direction: column;
        }
      }
    }

    .has-modal-in-modal .modal {
      .modal-dialog {
        .modal-content {
          height: auto;
        }
      }

      &.generic-geofence-search-modal,
      &.create-geofence-from-polygon-modal,
      &.geofence-list-selection-modal {
        .modal-dialog {
          margin-top: 2rem;
          max-width: unset;

          .modal-content {
            height: 76vh;
          }
        }
      }

      &.generic-geofence-search-modal {
        .modal-dialog {
          margin: 2rem;
        }
      }
    }
  }
</style>
